import { ConcreteEncodable } from "./ConcreteEncodable";

import { STPAcknowledgementEncoder } from "../../encoder/STPAcknowledgementEncoder";

import * as CubiqTS from "../../index";

export class STPAcknowledgement extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.stp.bridge.STPAcknowledgement";

  /*FID=1*/
  public senderReference: string;
  /*FID=2*/
  public status: CubiqTS.OrderDealState;
  /*FID=3*/
  public backOfficeReference: string;
  /*FID=4*/
  public details: string;
  /*FID=5*/
  public isAcknowledged: boolean;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = STPAcknowledgementEncoder.Instance;
    this.setEncodableType(STPAcknowledgement.enType);
    //Model
  }

  public toString(): string {
    return (
      "STPAcknowledgement[" +
      "senderReference=" +
      this.senderReference +
      "status=" +
      this.status +
      "backOfficeReference=" +
      this.backOfficeReference +
      "details=" +
      this.details +
      "isAcknowledged=" +
      this.isAcknowledged +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
